import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsRoundsAndSeriesSelected } from '../reducers/leagues_configs'
import {
  selectCloningStep,
  setCloningStep,
  setCloningModal,
} from '../reducers/cloning_steps'
import { CloningStepsEnum, CloningStepsModals } from '../constants'
import useSessionSaver from './useSessionSaver'
import { selectAllLeaguesRenamed } from '../reducers/session_saver'

const useCloningStepsActions = () => {
  const dispatch = useDispatch()
  const { startSessionJobs } = useSessionSaver()
  const roundsAndSeriesSelected = useSelector(selectIsRoundsAndSeriesSelected)
  const cloningStep = useSelector(selectCloningStep)
  const allLeaguesRenamed = useSelector(selectAllLeaguesRenamed)

  const isLastCloningStep = useMemo(() => {
    if (roundsAndSeriesSelected && cloningStep === CloningStepsEnum.DATES) {
      return true
    }

    return cloningStep === CloningStepsEnum.DATES
  }, [ cloningStep, roundsAndSeriesSelected ])

  const goToPrevCloningStep = useCallback(() => {
    if (cloningStep === CloningStepsEnum.BROWSE) {
      dispatch(setCloningModal(CloningStepsModals.CANCEL_SESSION))
      return
    }

    if (cloningStep > 0) {
      dispatch(setCloningStep(cloningStep - 1))
    }
  }, [ cloningStep ])

  const goToNextCloningStep = useCallback(() => {
    if (!isLastCloningStep) {
      if (cloningStep === CloningStepsEnum.RENAME && !allLeaguesRenamed) {
        dispatch(setCloningModal(CloningStepsModals.MISSING_LEAGUES_RENAMES))
        return
      }

      dispatch(setCloningStep(cloningStep + 1))
    } else {
      startSessionJobs()
    }
  }, [ cloningStep, isLastCloningStep, allLeaguesRenamed ])

  const confirmNextCloningStep = useCallback(() => {
    dispatch(setCloningModal(null))
    dispatch(setCloningStep(cloningStep + 1))
  }, [ cloningStep ])

  return {
    goToNextCloningStep,
    confirmNextCloningStep,
    goToPrevCloningStep,
    isLastCloningStep,
  }
}

export default useCloningStepsActions
